import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

import {Box, Stack, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {IconExit} from "../assets/icons/IconExit";
import {IconPhoneOutgoing} from "@tabler/icons-react";


function TransferCallNode({ id, data }) {

    const {name} = data;

    return (
        <Box className={"node transfer-call-node"} sx={{width: "auto", border: 1, p: 1, pr: 2, borderRadius: "8px", borderColor: "white", boxShadow: 1}}>
            <Handle type="target" position={Position.Left} id={id} />

            <Stack direction={"row"} gap={1} alignItems={"center"} sx={{color: grey[50]}}>
                <IconPhoneOutgoing size={11} color={grey[50]} />
              <Typography noWrap sx={{fontSize: 9, fontWeight: "bold", flex: 1 }} align={"center"}>{name || "Transfer Call"}</Typography>
            </Stack>
        </Box>
    );
}

export default memo(TransferCallNode);
